import { render, staticRenderFns } from "./SalaryAdd.vue?vue&type=template&id=9b079cb2&scoped=true&"
import script from "./SalaryAdd.vue?vue&type=script&lang=js&"
export * from "./SalaryAdd.vue?vue&type=script&lang=js&"
import style0 from "./SalaryAdd.css?vue&type=style&index=0&id=9b079cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b079cb2",
  null
  
)

export default component.exports